import { permissionGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("permission-group"),
  endpoint: "permission-groups",
  operations: permissionGroupsOps,
  roleView: [ROLE.PERMISSION_GROUP_VIEW, ROLE.PERMISSION_GROUP_ADMIN],
  roleAdmin: [ROLE.PERMISSION_GROUP_ADMIN],
  singularName: (t) => t("Role"),
  name: (t) => t("Roles"),
  sendCulture: true,
  baseRoute: "permission-group",
});

export default conf;
